import { mapMutations, mapGetters } from "vuex";
import { giftItemQuantity } from "../../api/helpers/shoppingCartHelper.js";
import { wcconfig } from "../../../wcConfig.js";
var toolTipFlag = false;
export default {
  computed: {
    ...mapGetters([
      "giftCartItems",
      "currencySign",
    ]),
    totalPrice() {
      let sum = this.price;
      return sum * this.quantity;
    },
    cartQuantity() {
      var item = { id: this.productId };
      const iq = giftItemQuantity(item, this.messageModel, this.giftCartItems);
      return iq + this.quantity;
    },
    maxQuantity() {
      var item = { id: this.productId };
      const iq = giftItemQuantity(item, this.messageModel, this.giftCartItems);
      return this.maxItemQuantity - iq;
    },
    getToolTipMessage() {
      return this.$t("message.giftEmailToolTipMessage");
    }
  },
  methods: {
    ...mapMutations([
      "Add_GiftcartItem",
      "UpdateGiftItemQuantity",
      "REMOVE_GIFTCART_ITEM"
    ]),
    closeModal() {
      this.$parent.closeModal();
    },
    fixQuantity() {
      if (this.cartQuantity > this.maxItemQuantity)
        this.quantity = this.maxQuantity;
      if (this.quantity == 0) this.quantity = 1;
      return "";
    },
    closeModalMobile() {
      this.$nextTick(() => {
        this.$parent.closeModal();
      });
    },
    inc() {
      this.quantity++;
    },
    dec() {
      this.quantity--;
    },
    getToolTipIcon() {
      return wcconfig.assets.questionMark;
    },
    showToolTip() {
      toolTipFlag = true;
      this.isShowToolTip = !this.isShowToolTip;
    },
    toolTipClick() {
      if (!toolTipFlag) this.isShowToolTip = false;
      toolTipFlag = false;
    },
    addToCart() {
      // this.$validator.validateAll().then(result => {
      //   if (result) {
          this.Add_GiftcartItem({
            item: {
              id: this.productId,
              code: this.product.ProductCode,
              name: this.product.Name,
              description: this.product.ShortDescription,
              photoUrl: this.product.PhotoUrl,
              tax: this.product.TaxRate,
              price: this.price
            },
            quantity: this.quantity,
            message: this.messageModel
          });
          //this.$refs.addModal.hideModal();
      //   }
      // });
      this.$router.push({name:'giftconfirm'});
    },
    addToCartMobile() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.Add_GiftcartItem({
            item: {
              id: this.productId,
              code: this.product.ProductCode,
              name: this.product.Name,
              description: this.product.ShortDescription,
              photoUrl: this.product.PhotoUrl,
              tax: this.product.TaxRate,
              price: this.price
            },
            quantity: this.quantity,
            message: this.messageModel
          });
          this.$nextTick(() => {
            this.$parent.closeModal();
          });
        }
      });
    },
    updateQt(event) {
      
      let qt;
      if(event.target)
        qt = parseInt(event.target.value);
      else
        qt = parseInt(event);

      if (!qt) {
        qt = 0;
      }
      this.UpdateGiftItemQuantity({
        item: this.cartItem,
        quantity: qt,
        message: this.cartItem.message
      });
    },
    removeCartItem(item) {
      this.REMOVE_GIFTCART_ITEM({ item: item });
    }
  }
};
